/**
 * <hy-sticky-header>: kompakte Sticky-Leiste für die Hauptzeile des Headers
 * (sections/hy-header.liquid, AP-194, ersetzt das bisherige position: sticky
 * auf dem GANZEN Header aus AP-29). Reine Erweiterung — ohne dieses Modul
 * (bzw. mit deaktiviertem "Sticky Header"-Setting) bleibt das Element ein
 * gewöhnliches <div>, kein Funktionsverlust, nur kein Sticky-Effekt.
 *
 * Zwei unabhängige Zustände, beide ausschließlich über Attribute (kein
 * inneres Markup-Umschreiben — gleiches Prinzip wie <hy-header-nav>):
 *
 * 1. [data-hy-compact] — ein IntersectionObserver beobachtet
 *    .hy-header__bar (Topbar+Hauptzeile+Navigationszeile als Ganzes). Erst
 *    wenn dieser gesamte Block vollständig aus dem Bild gescrollt ist
 *    (isIntersecting: false UND boundingClientRect.top < 0, also nach oben
 *    hinausgescrollt statt noch unterhalb des Viewports), gilt die Zeile als
 *    "kompakt-fähig" und wird per CSS position: fixed. Scrollt der Nutzer so
 *    weit zurück, dass der echte Header wieder sichtbar wird, verschwindet
 *    [data-hy-compact] sofort wieder (kein doppelter Header sichtbar).
 * 2. [data-hy-compact-visible] — nur relevant, während [data-hy-compact]
 *    gesetzt ist. Ein passiver, per requestAnimationFrame gedrosselter
 *    scroll-Listener vergleicht die Scroll-Richtung: runter entfernt das
 *    Attribut (Zeile schiebt sich per CSS-Transition aus dem Bild), hoch
 *    (oder ganz oben auf der Seite) setzt es wieder.
 *
 * IntersectionObserver.disconnect() läuft absichtlich nicht über das
 * AbortController-Signal (das kennt nur addEventListener) — deshalb
 * explizit in disconnectedCallback, gleiches Prinzip wie der
 * matchMedia-Listener in assets/hy-header-nav.js.
 *
 * Bugfix 1 (Header-Sitzung ab 04.09.2026): #direction wurde bisher
 * ausschließlich im rAF-gedrosselten scroll-Listener aktualisiert, der
 * IntersectionObserver-Callback aber rief #render() mit dem jeweils zuletzt
 * bekannten Wert auf — beide laufen unabhängig voneinander getaktet. Genau
 * in dem Moment, in dem die Zeile die Sichtbarkeitsschwelle beim
 * Runterscrollen überquert, konnte der Observer-Callback vor dem nächsten
 * Scroll-Tick feuern und dabei noch eine veraltete Richtung sehen —
 * sichtbares Symptom: die Kompaktleiste blitzte kurz auf und verschwand
 * sofort wieder. Erster Fix-Versuch ließ #syncDirection() synchron in BEIDEN
 * Callbacks laufen — Bugfix 4 unten ersetzt das durch eine sauberere Lösung
 * mit nur einem schreibenden Callback.
 *
 * Bugfix 2, per Playwright gegen hyter-theme-lab empirisch verifiziert
 * (window.scrollY UND document.documentElement.scrollHeight bei jedem
 * scroll-Event mitprotokolliert): Bilder/Schriften, die nach dem ersten
 * Scroll noch nachladen, verändern die Seitenhöhe — scrollHeight sinkt
 * dabei zum Teil merklich (beobachteter Fall: 78px). Steht der Nutzer nahe
 * am bisherigen Seitenende, klemmt der Browser window.scrollY passiv auf
 * die neue, kleinere Grenze — das feuert ein 'scroll'-Event mit KLEINEREM
 * scrollY, exakt wie ein echtes Hochscrollen, obwohl der Nutzer nichts
 * getan hat.
 *
 * qs-Fund (Finish-Review, Header-Nacharbeit): Die erste Fassung glich
 * #lastScrollY bei JEDER scrollHeight-Änderung aus, unabhängig davon, ob
 * tatsächlich geklemmt wurde. Das erzeugte einen neuen, spiegelbildlichen
 * Flacker-Fall: wächst scrollHeight (z. B. Web-Font-Swap-Reflow), während
 * der Nutzer aktiv woanders auf der Seite nach unten scrollt (nicht am
 * Seitenende), hätte die blinde Kompensation ein negatives Delta erzeugt
 * und fälschlich 'up' gemeldet — derselbe Fehler wie Bugfix 2 selbst
 * beheben sollte, nur umgekehrt ausgelöst. #syncDirection() erkennt eine
 * echte Klemmung jetzt gezielt: nur wenn scrollHeight GESCHRUMPFT ist UND
 * currentY nach der Änderung praktisch exakt an der neuen maximalen
 * Scroll-Position klebt (Toleranz 1px — genau das Muster, das eine
 * passive Klemmung erzeugt, ein normaler Scroll landet dort so gut wie nie
 * zufällig). Trifft das zu, wird der Tick als reiner Klemmungs-Effekt
 * verworfen (Referenzpunkt nachgezogen, aber keine Richtung daraus
 * abgeleitet) — in jedem anderen Fall (wachsende Höhe, schrumpfende Höhe
 * fernab vom Seitenende) zählt die tatsächliche Bewegung unverändert.
 *
 * DIRECTION_THRESHOLD bleibt zusätzlich als zweite, unabhängige Absicherung
 * gegen echtes Sub-Pixel-Scroll-Wackeln (Trackpad-Momentum, Rundungsfehler)
 * bestehen, das mit derselben Ursache nichts zu tun hat.
 *
 * Bugfix 3 (Header-Nacharbeit, Sitzung ab 09.09.2026): Trotz Bugfix 1/2 blieb
 * ein drittes Flacker-Fenster übrig, das Live gegen die Düperthal-Vorschau
 * weiterhin auftrat. Ursache: DIRECTION_THRESHOLD filtert nur echtes
 * Sub-Pixel-Rauschen heraus, verhindert aber nicht, dass ein einzelner,
 * kurzer echter Gegen-Ausschlag (Trackpad-Rebound/-Momentum, typischerweise
 * 10–20px) #direction sofort umschaltet — auch wenn die eigentliche
 * Scrollbewegung unverändert in die andere Richtung weiterläuft. Ein solcher
 * Ausschlag reicht, um die Kompaktleiste für einen Frame sichtbar zu
 * schalten, bevor der nächste Tick der fortgesetzten Bewegung korrigiert.
 * Fix: #direction wird nicht mehr bei jedem einzelnen über DIRECTION_THRESHOLD
 * liegenden Tick übernommen, sondern erst, wenn dieselbe Momentanrichtung
 * entweder über eine kumulative Distanz von DIRECTION_COMMIT_DISTANCE oder
 * über ein Zeitfenster von DIRECTION_HOLD_MS hinweg konsistent bleibt (je
 * nachdem, was zuerst zutrifft — ein einzelner großer Sprung committet damit
 * weiterhin sofort, ein kurzer Ausschlag dagegen nie, ein langsamer aber
 * echter Richtungswechsel nach spätestens DIRECTION_HOLD_MS). #lastScrollY
 * wird weiterhin bei jedem Tick über der Rausch-Schwelle nachgezogen (nicht
 * erst beim Committen), damit die Distanzmessung nicht durch liegengebliebene
 * alte Referenzpunkte verfälscht wird.
 *
 * Bugfix 4 (Header-Nacharbeit, Sitzung ab 09.09.2026, Menschen-Fund: Flackern
 * live weiterhin beobachtet, per echten Mausrad-/Trackpad-Ereignissen
 * reproduziert — ein einzelner großer scrollTo()-Sprung reproduziert diese
 * Variante NICHT zuverlässig): Der IntersectionObserver-Callback rief bis
 * hierhin zusätzlich zum rAF-Scroll-Pfad noch #syncDirection() auf (Bugfix
 * 1s ursprünglicher Fix). Das ist unnötig UND riskant: requestAnimationFrame-
 * Callbacks laufen als Teil des Rendering-Schritts VOR der Aktualisierung von
 * IntersectionObserver-Einträgen (Browser-Spezifikation) — der rAF-Handler
 * für den aktuellen Frame hat #direction also bereits mit dem aktuellen
 * window.scrollY aktualisiert, bevor der Observer für denselben Frame
 * überhaupt feuert. Ein zweiter, unabhängiger Aufruf von #syncDirection() im
 * Observer-Callback bringt keinen Mehrwert, schafft aber einen zweiten
 * Schreibzugriff auf denselben Zustand (#pendingDirection/#lastScrollY) —
 * bei schnellen, dicht aufeinanderfolgenden echten Scroll-Ticks (Mausrad-
 * Bursts) ein vermeidbares Risiko für genau die Art von Wettlaufsituation,
 * die Bugfix 1 eigentlich beheben sollte. Fix: Der Observer-Callback setzt
 * nur noch #eligible und rendert mit dem bereits vom rAF-Pfad aktuellen
 * #direction — #syncDirection() hat jetzt genau einen Aufrufer.
 *
 * R17-Fix (Header-Nacharbeit, Folgesitzung ab 09.09.2026, Menschen-Fund mit
 * exakter Pixelmessung — kein Timing-/Hysterese-Problem wie Bugfix 1-5,
 * sondern ein reiner Layout-Bug, unabhängig vom Eingabegerät):
 * .hy-header__bar hat height: auto, kein min-height — sobald
 * [data-hy-compact] greift, wird dieses Element per CSS position: fixed
 * (nur ab 48rem) komplett aus dem Dokumentfluss genommen, unabhängig von
 * [data-hy-compact-visible]. .hy-header__bar kollabiert dadurch schlagartig
 * um genau die eigene Höhe (gemessen: ~103px in einem einzigen Frame), der
 * gesamte Seiteninhalt darunter rutscht abrupt nach oben (und beim
 * Zurückscrollen symmetrisch zurück). Fix: ein ResizeObserver misst laufend
 * die eigene Rahmenkastenhöhe und schreibt sie als
 * --hy-sticky-header-reserved-height auf .hy-header__bar — die CSS-Regel
 * .hy-header__bar:has(hy-sticky-header[data-hy-compact]) im Stylesheet von
 * sections/hy-header.liquid reserviert damit exakt diese Höhe als
 * padding-block-start, sobald position: fixed greift.
 */
// Toleranz gegen Gleitkomma-/Sub-Pixel-Abweichungen beim Vergleich von
// window.scrollY gegen die berechnete maximale Scroll-Position.
const CLAMP_TOLERANCE = 1;
// Rausch-Schwelle — ignoriert echtes Sub-Pixel-Scroll-Wackeln komplett
// (aktualisiert nicht einmal #lastScrollY), hat mit der Hysterese aus
// Bugfix 3 nichts zu tun.
const DIRECTION_THRESHOLD = 8;
// Bugfix 3: eine Momentanrichtung wird sofort committet, sobald seit ihrem
// ersten Auftreten kumulativ so viel Strecke zurückgelegt wurde — ein
// einzelner großer Scroll-Sprung committet damit ohne Verzögerung.
const DIRECTION_COMMIT_DISTANCE = 24;
// Bugfix 3: alternativ committet dieselbe Momentanrichtung spätestens nach
// dieser Zeit, auch bei vielen kleinen Ticks (langsames Trackpad-Pan).
const DIRECTION_HOLD_MS = 120;

class HyStickyHeader extends HTMLElement {
  #controller = null;
  #observer = null;
  // R17-Fix (Header-Nacharbeit, Folgesitzung ab 09.09.2026): misst laufend
  // die eigene Rahmenkastenhöhe und schreibt sie als Custom Property auf
  // .hy-header__bar — siehe ausführlicher Kommentar bei der CSS-Regel
  // .hy-header__bar:has(hy-sticky-header[data-hy-compact]) im Stylesheet.
  #resizeObserver = null;
  #bar = null;
  #eligible = false;
  // reviewer-Fund: nicht mit 'up' vorbelegen — ein Seitenaufruf, der bereits
  // gescrollt startet (Zurück-Navigation, Anker-Sprung), könnte sonst vor
  // dem ersten echten scroll-Event fälschlich als "nach oben gescrollt"
  // gelten und die Kompaktleiste ungewollt sofort sichtbar machen. null
  // fällt in #render() auf den scrollY < 1-Fallback zurück, bis eine
  // echte Richtung bekannt ist.
  #direction = null;
  // Bugfix 3: Momentanrichtung, die gerade "zur Bestätigung ansteht", plus
  // wann sie zuerst auftrat und wie viel Strecke seitdem kumuliert wurde.
  #pendingDirection = null;
  #pendingSince = 0;
  #pendingDistance = 0;
  #lastScrollY = 0;
  #lastScrollHeight = 0;
  #ticking = false;

  connectedCallback() {
    const bar = this.closest('.hy-header__bar');
    if (!bar) return;
    this.#bar = bar;

    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.#lastScrollY = window.scrollY;
    this.#lastScrollHeight = document.documentElement.scrollHeight;

    this.#observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[entries.length - 1];
        const nextEligible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        const enteringCompact = nextEligible && !this.#eligible;
        this.#eligible = nextEligible;
        if (enteringCompact) this.#renderWithoutTransition();
        else this.#render();
      },
      { threshold: 0 },
    );
    this.#observer.observe(bar);

    // R17-Fix: eigene Rahmenkastenhöhe laufend messen (nicht nur einmalig),
    // damit Logo-/Icon-Änderungen, Custom-Element-Nachladen (z. B.
    // <shopify-account>) oder ein Breakpoint-Wechsel die reservierte Höhe
    // korrekt nachziehen. AP-268: im Kompaktzustand NICHT nachmessen — der
    // Header-Stil "modern" macht die fixierte Leiste niedriger (64 statt
    // 96 px), die Reserve muss aber die Höhe der Zeile im Fluss bleiben,
    // sonst springt der Inhalt darunter. Im klassischen Stil sind beide
    // Höhen gleich, dort ändert sich nichts.
    this.#resizeObserver = new ResizeObserver((entries) => {
      if (this.hasAttribute('data-hy-compact')) return;
      const entry = entries[entries.length - 1];
      const height = entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height;
      this.#bar.style.setProperty('--hy-sticky-header-reserved-height', `${height}px`);
    });
    this.#resizeObserver.observe(this);

    window.addEventListener('scroll', this.#handleScroll, { signal, passive: true });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
    this.#resizeObserver?.disconnect();
    this.#resizeObserver = null;
    this.#bar = null;
    this.#controller?.abort();
    this.#controller = null;
  }

  #handleScroll = () => {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      this.#syncDirection();
      this.#render();
      this.#ticking = false;
    });
  };

  // Liest die aktuelle Scroll-Position gegen #lastScrollY — einziger
  // Aufrufer ist #handleScroll (Bugfix 4, s. Klassenkommentar). Erkennt
  // zuerst eine echte passive Scroll-Klemmung durch schrumpfenden
  // Seiteninhalt (Bugfix 2, gezielt statt blind), bevor die tatsächliche
  // Bewegung gegen DIRECTION_THRESHOLD geprüft und die Hysterese aus
  // Bugfix 3 angewendet wird.
  #syncDirection() {
    const scrollHeight = document.documentElement.scrollHeight;
    const heightShrank = scrollHeight < this.#lastScrollHeight;
    this.#lastScrollHeight = scrollHeight;

    const currentY = window.scrollY;
    const maxScrollY = Math.max(0, scrollHeight - window.innerHeight);
    const wasClamped = heightShrank && Math.abs(currentY - maxScrollY) < CLAMP_TOLERANCE;

    if (wasClamped) {
      this.#lastScrollY = currentY;
      return;
    }

    const delta = currentY - this.#lastScrollY;
    if (Math.abs(delta) < DIRECTION_THRESHOLD) return;
    this.#lastScrollY = currentY;

    const instant = delta > 0 ? 'down' : 'up';
    if (instant === this.#pendingDirection) {
      this.#pendingDistance += Math.abs(delta);
    } else {
      this.#pendingDirection = instant;
      this.#pendingSince = performance.now();
      this.#pendingDistance = Math.abs(delta);
    }

    const held = performance.now() - this.#pendingSince >= DIRECTION_HOLD_MS;
    if (this.#pendingDistance >= DIRECTION_COMMIT_DISTANCE || held) {
      this.#direction = instant;
    }
  }

  #render() {
    this.toggleAttribute('data-hy-compact', this.#eligible);

    const visible = this.#eligible && (this.#direction === 'up' || window.scrollY < 1);
    this.toggleAttribute('data-hy-compact-visible', visible);
  }

  // Bugfix 5 (Header-Nacharbeit, Sitzung ab 09.09.2026, per Sampling der
  // TATSÄCHLICH gerenderten Sichtbarkeit gefunden, nicht nur der Attribute):
  // Der eigentliche Flash war die ganze Zeit ein reiner CSS-Effekt, unabhängig
  // von #direction/der Hysterese aus Bugfix 3/4. [data-hy-compact] allein
  // trägt bereits eine transform/visibility-Transition (für das spätere Ein-/
  // Ausblenden über [data-hy-compact-visible]) — beim ALLERERSTEN Eintritt in
  // [data-hy-compact] (Wechsel false→true) sprang die Leiste dadurch selbst
  // sichtbar auf position: fixed; transform: none (= oben am Viewport-Rand,
  // top: 0, computed) und animierte erst DANACH über --hy-motion-duration zu
  // translateY(-100%), während visibility die gesamte Animation über
  // "visible" blieb (transition-delay). Gemessen: ~150-200ms lang tatsächlich
  // sichtbar oben im Bild, bevor sie wieder verschwand — exakt das gemeldete
  // Aufblitzen, komplett unabhängig davon, was #direction gerade war. Fix:
  // beim Eintritt in [data-hy-compact] Transitions einmalig hart abschalten
  // (kein Slide-Effekt beim erstmaligen "Einparken" nötig — das Element soll
  // dort unsichtbar ankommen, nicht sichtbar hindurch), Reflow erzwingen,
  // dann wieder freigeben — ab dem nächsten Zustandswechsel (Scroll-Richtung)
  // greift die Transition wieder normal.
  #renderWithoutTransition() {
    this.style.transitionProperty = 'none';
    this.#render();
    void this.offsetHeight; // Reflow erzwingen, bevor die Transition wieder greift.
    this.style.transitionProperty = '';
  }
}

customElements.define('hy-sticky-header', HyStickyHeader);
